
// NOTE: Imports are generated by https://github.com/truvity/rules_openapi/src/master/exe/prepare-deps/ts.go

import { Observable, of, from } from './rxjsStub';
import { mergeMap, map } from './rxjsStub';
import { Int64 } from '@truvity/rules_openapi';







export class ApiError {
    /**
    * The error code.
    */
    'Code': string;
    /**
    * The error message.
    */
    'Message': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "Code",
            baseName: "Code",
            type: "string",
            format: "",
            required: true,
        },
        {
            name: "Message",
            baseName: "Message",
            type: "string",
            format: "",
            required: true,
        },
    ];

    static getAttributeTypeMap() {
        return ApiError.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<ApiError>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for ApiError its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'ApiError', ''));
    }
}








/**
 * Credential state.
 * @export
 * @type CredentialStateEnum
 */
export const CredentialStateEnum = {
    'Draft': 'draft',
    'Issued': 'issued',
    'Abandoned': 'abandoned',
} as const;
export type CredentialStateEnum = typeof CredentialStateEnum[keyof typeof CredentialStateEnum];

export class Credential {
    /**
    * A dictionary of claims for the credential. A claim is an assertion made about a subject.
    */
    'claims': any;
    'meta': CredentialsMeta;
    /**
    * The revision number of the credential.
    */
    'revision': number;
    /**
    * Credential state.
    */
    'state': CredentialStateEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "claims",
            baseName: "claims",
            type: "any",
            format: "",
            required: true,
        },
        {
            name: "meta",
            baseName: "meta",
            type: "CredentialsMeta",
            format: "",
            required: true,
        },
        {
            name: "revision",
            baseName: "revision",
            type: "number",
            format: "",
            required: true,
        },
        {
            name: "state",
            baseName: "state",
            type: "CredentialStateEnum",
            format: "",
            required: true,
        },
    ];

    static getAttributeTypeMap() {
        return Credential.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<Credential>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for Credential its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'Credential', ''));
    }
}









export class CredentialCreatePayload {
    /**
    * The JSON Schema associated with the credential.
    */
    'jsonSchema': any;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "jsonSchema",
            baseName: "jsonSchema",
            type: "any",
            format: "",
            required: true,
        },
    ];

    static getAttributeTypeMap() {
        return CredentialCreatePayload.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<CredentialCreatePayload>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for CredentialCreatePayload its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'CredentialCreatePayload', ''));
    }
}









export class CredentialCreateResponse {
    /**
    * The DID (Decentralized Identifier) of the credential.
    */
    'id': string;
    /**
    * The revision number of the credential.
    */
    'revision': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "id",
            baseName: "id",
            type: "string",
            format: "",
            required: true,
        },
        {
            name: "revision",
            baseName: "revision",
            type: "number",
            format: "",
            required: true,
        },
    ];

    static getAttributeTypeMap() {
        return CredentialCreateResponse.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<CredentialCreateResponse>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for CredentialCreateResponse its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'CredentialCreateResponse', ''));
    }
}









export class CredentialPatchPayload {
    'update'?: CredentialPatchPayloadUpdate;
    'remove'?: CredentialPatchPayloadRemove;
    /**
    * The incremented revision of the credential.
    */
    'revision': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "update",
            baseName: "update",
            type: "CredentialPatchPayloadUpdate",
            format: "",
            required: false,
        },
        {
            name: "remove",
            baseName: "remove",
            type: "CredentialPatchPayloadRemove",
            format: "",
            required: false,
        },
        {
            name: "revision",
            baseName: "revision",
            type: "number",
            format: "",
            required: true,
        },
    ];

    static getAttributeTypeMap() {
        return CredentialPatchPayload.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<CredentialPatchPayload>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for CredentialPatchPayload its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'CredentialPatchPayload', ''));
    }
}









/**
* The remove operation that will remove from existing claims or meta the list or claims or meta provided.
*/
export class CredentialPatchPayloadRemove {
    /**
    * The list of claims that will be removed from the existing ones. A claim is an assertion made about a subject.
    */
    'claims'?: Array<string>;
    'meta'?: CredentialPatchPayloadRemoveMeta;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "claims",
            baseName: "claims",
            type: "Array<string>",
            format: "",
            required: false,
        },
        {
            name: "meta",
            baseName: "meta",
            type: "CredentialPatchPayloadRemoveMeta",
            format: "",
            required: false,
        },
    ];

    static getAttributeTypeMap() {
        return CredentialPatchPayloadRemove.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<CredentialPatchPayloadRemove>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for CredentialPatchPayloadRemove its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'CredentialPatchPayloadRemove', ''));
    }
}









/**
* The metadata fields that will be removed from the existing one.
*/
export class CredentialPatchPayloadRemoveMeta {
    /**
    * A role an entity might perform by possessing one or more verifiable credentials and generating presentations from them. A holder is usually, but not always, a subject of the verifiable credentials they are holding.
    */
    'holder'?: boolean;
    /**
    * A thing about which claims are made.
    */
    'subject'?: boolean;
    /**
    * The date and time then the credential ceases to be valid.
    */
    'expirationDate'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "holder",
            baseName: "holder",
            type: "boolean",
            format: "",
            required: false,
        },
        {
            name: "subject",
            baseName: "subject",
            type: "boolean",
            format: "",
            required: false,
        },
        {
            name: "expirationDate",
            baseName: "expirationDate",
            type: "boolean",
            format: "",
            required: false,
        },
    ];

    static getAttributeTypeMap() {
        return CredentialPatchPayloadRemoveMeta.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<CredentialPatchPayloadRemoveMeta>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for CredentialPatchPayloadRemoveMeta its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'CredentialPatchPayloadRemoveMeta', ''));
    }
}









/**
* The update operation that will merge existing claims or meta with the new ones.
*/
export class CredentialPatchPayloadUpdate {
    /**
    * The claims that will be merged with existing ones. A claim is an assertion made about a subject.
    */
    'claims'?: any;
    'meta'?: CredentialPatchPayloadUpdateMeta;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "claims",
            baseName: "claims",
            type: "any",
            format: "",
            required: false,
        },
        {
            name: "meta",
            baseName: "meta",
            type: "CredentialPatchPayloadUpdateMeta",
            format: "",
            required: false,
        },
    ];

    static getAttributeTypeMap() {
        return CredentialPatchPayloadUpdate.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<CredentialPatchPayloadUpdate>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for CredentialPatchPayloadUpdate its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'CredentialPatchPayloadUpdate', ''));
    }
}









/**
* The metadata that will be merged with existing one.
*/
export class CredentialPatchPayloadUpdateMeta {
    /**
    * A role an entity might perform by possessing one or more verifiable credentials and generating presentations from them. A holder is usually, but not always, a subject of the verifiable credentials they are holding.
    */
    'holder'?: string;
    /**
    * A thing about which claims are made.
    */
    'subject'?: string;
    /**
    * The date and time then the credential ceases to be valid.
    */
    'expirationDate'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "holder",
            baseName: "holder",
            type: "string",
            format: "",
            required: false,
        },
        {
            name: "subject",
            baseName: "subject",
            type: "string",
            format: "",
            required: false,
        },
        {
            name: "expirationDate",
            baseName: "expirationDate",
            type: "string",
            format: "",
            required: false,
        },
    ];

    static getAttributeTypeMap() {
        return CredentialPatchPayloadUpdateMeta.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<CredentialPatchPayloadUpdateMeta>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for CredentialPatchPayloadUpdateMeta its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'CredentialPatchPayloadUpdateMeta', ''));
    }
}









export class CredentialUpdatePayload {
    /**
    * The new claims that will replace the existing ones. A claim is an assertion made about a subject.
    */
    'claims': any;
    'meta'?: CredentialUpdatePayloadMeta;
    /**
    * The incremented revision of the credential.
    */
    'revision': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "claims",
            baseName: "claims",
            type: "any",
            format: "",
            required: true,
        },
        {
            name: "meta",
            baseName: "meta",
            type: "CredentialUpdatePayloadMeta",
            format: "",
            required: false,
        },
        {
            name: "revision",
            baseName: "revision",
            type: "number",
            format: "",
            required: true,
        },
    ];

    static getAttributeTypeMap() {
        return CredentialUpdatePayload.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<CredentialUpdatePayload>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for CredentialUpdatePayload its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'CredentialUpdatePayload', ''));
    }
}









/**
* The new metadata information that will replace the existing one.
*/
export class CredentialUpdatePayloadMeta {
    /**
    * A role an entity might perform by possessing one or more verifiable credentials and generating presentations from them. A holder is usually, but not always, a subject of the verifiable credentials they are holding.
    */
    'holder'?: string;
    /**
    * A thing about which claims are made.
    */
    'subject'?: string;
    /**
    * The date and time then the credential ceases to be valid.
    */
    'expirationDate'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "holder",
            baseName: "holder",
            type: "string",
            format: "",
            required: false,
        },
        {
            name: "subject",
            baseName: "subject",
            type: "string",
            format: "",
            required: false,
        },
        {
            name: "expirationDate",
            baseName: "expirationDate",
            type: "string",
            format: "",
            required: false,
        },
    ];

    static getAttributeTypeMap() {
        return CredentialUpdatePayloadMeta.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<CredentialUpdatePayloadMeta>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for CredentialUpdatePayloadMeta its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'CredentialUpdatePayloadMeta', ''));
    }
}









export class CredentialUpdateResponse {
    /**
    * The DID (Decentralized Identifier) of the credential.
    */
    'id': string;
    /**
    * The incremented revision of the credential.
    */
    'revision': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "id",
            baseName: "id",
            type: "string",
            format: "",
            required: true,
        },
        {
            name: "revision",
            baseName: "revision",
            type: "number",
            format: "",
            required: true,
        },
    ];

    static getAttributeTypeMap() {
        return CredentialUpdateResponse.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<CredentialUpdateResponse>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for CredentialUpdateResponse its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'CredentialUpdateResponse', ''));
    }
}









export class Credentials {
    /**
    * Array of credentials.
    */
    'items': Array<CredentialsItems>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "items",
            baseName: "items",
            type: "Array<CredentialsItems>",
            format: "",
            required: true,
        },
    ];

    static getAttributeTypeMap() {
        return Credentials.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<Credentials>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for Credentials its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'Credentials', ''));
    }
}








/**
 * Credential state.
 * @export
 * @type CredentialsItemsStateEnum
 */
export const CredentialsItemsStateEnum = {
    'Draft': 'draft',
    'Issued': 'issued',
    'Abandoned': 'abandoned',
} as const;
export type CredentialsItemsStateEnum = typeof CredentialsItemsStateEnum[keyof typeof CredentialsItemsStateEnum];

export class CredentialsItems {
    /**
    * A dictionary of claims for the credential. A claim is an assertion made about a subject.
    */
    'claims': any;
    'meta': CredentialsMeta;
    /**
    * The revision number of the credential.
    */
    'revision': number;
    /**
    * Credential state.
    */
    'state': CredentialsItemsStateEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "claims",
            baseName: "claims",
            type: "any",
            format: "",
            required: true,
        },
        {
            name: "meta",
            baseName: "meta",
            type: "CredentialsMeta",
            format: "",
            required: true,
        },
        {
            name: "revision",
            baseName: "revision",
            type: "number",
            format: "",
            required: true,
        },
        {
            name: "state",
            baseName: "state",
            type: "CredentialsItemsStateEnum",
            format: "",
            required: true,
        },
    ];

    static getAttributeTypeMap() {
        return CredentialsItems.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<CredentialsItems>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for CredentialsItems its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'CredentialsItems', ''));
    }
}









/**
* Additional metadata. Includes specific information such as the holder, subject, expiration date, and other relevant details for the credential.
*/
export class CredentialsMeta {
    /**
    * The DID (Decentralized Identifier) of the credential.
    */
    'id': string;
    /**
    * The $id of the credential schema.
    */
    'credentialSchemaId': string;
    /**
    * The date and time then the credential ceases to be valid.
    */
    'expirationDate'?: string;
    /**
    * A role an entity might perform by possessing one or more verifiable credentials and generating presentations from them. A holder is usually, but not always, a subject of the verifiable credentials they are holding.
    */
    'holder'?: string;
    /**
    * A thing about which claims are made.
    */
    'subject'?: string;
    'issuanceMeta'?: CredentialsMetaIssuanceMeta;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "id",
            baseName: "id",
            type: "string",
            format: "",
            required: true,
        },
        {
            name: "credentialSchemaId",
            baseName: "credentialSchemaId",
            type: "string",
            format: "",
            required: true,
        },
        {
            name: "expirationDate",
            baseName: "expirationDate",
            type: "string",
            format: "",
            required: false,
        },
        {
            name: "holder",
            baseName: "holder",
            type: "string",
            format: "",
            required: false,
        },
        {
            name: "subject",
            baseName: "subject",
            type: "string",
            format: "",
            required: false,
        },
        {
            name: "issuanceMeta",
            baseName: "issuanceMeta",
            type: "CredentialsMetaIssuanceMeta",
            format: "",
            required: false,
        },
    ];

    static getAttributeTypeMap() {
        return CredentialsMeta.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<CredentialsMeta>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for CredentialsMeta its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'CredentialsMeta', ''));
    }
}









/**
* Metadata containing information related to the issuance process. It includes specific information such as the issuer and issuance date of the credential.
*/
export class CredentialsMetaIssuanceMeta {
    /**
    * A role an entity can perform by asserting claims about one or more subjects, creating a verifiable credential from these claims, and transmitting the verifiable credential to a holder.
    */
    'issuer': string;
    /**
    * The date and time the credential becomes valid, which could be a date and time in the future.
    */
    'issuanceDate': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "issuer",
            baseName: "issuer",
            type: "string",
            format: "",
            required: true,
        },
        {
            name: "issuanceDate",
            baseName: "issuanceDate",
            type: "string",
            format: "",
            required: true,
        },
    ];

    static getAttributeTypeMap() {
        return CredentialsMetaIssuanceMeta.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<CredentialsMetaIssuanceMeta>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for CredentialsMetaIssuanceMeta its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'CredentialsMetaIssuanceMeta', ''));
    }
}








/**
 * The error code.
 * @export
 * @type ValidationErrorsResponseCodeEnum
 */
export const ValidationErrorsResponseCodeEnum = {
    'ECREDENTIALSCHEMAVALIDATION': 'ECREDENTIALSCHEMAVALIDATION',
    'ECREDENTIALSCHEMAINVALID': 'ECREDENTIALSCHEMAINVALID',
} as const;
export type ValidationErrorsResponseCodeEnum = typeof ValidationErrorsResponseCodeEnum[keyof typeof ValidationErrorsResponseCodeEnum];

export class ValidationErrorsResponse {
    /**
    * The error code.
    */
    'code': ValidationErrorsResponseCodeEnum;
    /**
    * The error message.
    */
    'message'?: string;
    /**
    * The list of errors.
    */
    'errors': Array<ValidationErrorsResponseErrors>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "code",
            baseName: "code",
            type: "ValidationErrorsResponseCodeEnum",
            format: "",
            required: true,
        },
        {
            name: "message",
            baseName: "message",
            type: "string",
            format: "",
            required: false,
        },
        {
            name: "errors",
            baseName: "errors",
            type: "Array<ValidationErrorsResponseErrors>",
            format: "",
            required: true,
        },
    ];

    static getAttributeTypeMap() {
        return ValidationErrorsResponse.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<ValidationErrorsResponse>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for ValidationErrorsResponse its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'ValidationErrorsResponse', ''));
    }
}









export class ValidationErrorsResponseErrors {
    /**
    * The error code.
    */
    'keyword': string;
    /**
    * The path where the error occurred.
    */
    'instancePath': string;
    /**
    * The error message.
    */
    'message'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<TypeAttributeDescriptor> = [
        {
            name: "keyword",
            baseName: "keyword",
            type: "string",
            format: "",
            required: true,
        },
        {
            name: "instancePath",
            baseName: "instancePath",
            type: "string",
            format: "",
            required: true,
        },
        {
            name: "message",
            baseName: "message",
            type: "string",
            format: "",
            required: false,
        },
    ];

    static getAttributeTypeMap() {
        return ValidationErrorsResponseErrors.attributeTypeMap;
    }

    static getTypeSerializer() {
        return ObjectSerializer;
    }
    
    public constructor(defaultValues?: Partial<ValidationErrorsResponseErrors>, skipDefaultValuesInitialization?: boolean) {
        /**
         * For performance reasons, we don't want to start values initialization during active 
         * initialization in the ʻObjectSerializer`.
         */
        if (skipDefaultValuesInitialization) {
            if (defaultValues === undefined) {
                return;
            } else {
                console.warn(`To prevent values initialization for ValidationErrorsResponseErrors its 'defaultValues' must be undefined`);
            }
        }
        Object.assign(this, ObjectSerializer.initialize(defaultValues, 'ValidationErrorsResponseErrors', ''));
    }
}




import JSONBigInt from 'json-bigint';
import BigNumber from 'bignumber.js';

const JSONBigIntNative = JSONBigInt({
    useNativeBigInt: true,
});

const supportedMediaTypes: { [mediaType: string]: number } = {
  "application/json": Infinity,
  "application/octet-stream": 0
}

export type TypeAttributeDescriptor = {
    name: string;
    baseName: string;
    type: string;
    format: string;
    required: boolean;
};

export type TypeSerializer = {
    serialize: (data: any, type: string, format: string) => any;
    deserialize: (data: any, type: string, format: string) => any;
    initialize: (data: any, type: string, format: string) => any;
};

export type EnumTypeDescriptor = Record<string, string>;
export type TypeDescriptor = ((value?: any) => any) & {
    serialize: (value: any) => any;
    deserialize: (value: any) => any;
};
export type TypeModelDescriptor = (new (value?: any, skipDefaultValuesInitialization?: boolean) => any) & {
    discriminator?: string;
    getTypeSerializer: () => TypeSerializer;
    getAttributeTypeMap: () => Array<TypeAttributeDescriptor>;
};

export type ApiTypeDescriptor = TypeDescriptor | TypeModelDescriptor | EnumTypeDescriptor;

const typeMap: Map<string, ApiTypeDescriptor> = new Map<string, ApiTypeDescriptor>([
    ['ApiError', ApiError],
    ['Credential', Credential],
    ['CredentialStateEnum', CredentialStateEnum],
    ['CredentialsMeta', CredentialsMeta],
    ['CredentialCreatePayload', CredentialCreatePayload],
    ['CredentialCreateResponse', CredentialCreateResponse],
    ['CredentialPatchPayload', CredentialPatchPayload],
    ['CredentialPatchPayloadRemove', CredentialPatchPayloadRemove],
    ['CredentialPatchPayloadUpdate', CredentialPatchPayloadUpdate],
    ['CredentialPatchPayloadRemove', CredentialPatchPayloadRemove],
    ['CredentialPatchPayloadRemoveMeta', CredentialPatchPayloadRemoveMeta],
    ['CredentialPatchPayloadRemoveMeta', CredentialPatchPayloadRemoveMeta],
    ['CredentialPatchPayloadUpdate', CredentialPatchPayloadUpdate],
    ['CredentialPatchPayloadUpdateMeta', CredentialPatchPayloadUpdateMeta],
    ['CredentialPatchPayloadUpdateMeta', CredentialPatchPayloadUpdateMeta],
    ['CredentialUpdatePayload', CredentialUpdatePayload],
    ['CredentialUpdatePayloadMeta', CredentialUpdatePayloadMeta],
    ['CredentialUpdatePayloadMeta', CredentialUpdatePayloadMeta],
    ['CredentialUpdateResponse', CredentialUpdateResponse],
    ['Credentials', Credentials],
    ['CredentialsItems', CredentialsItems],
    ['CredentialsItems', CredentialsItems],
    ['CredentialsItemsStateEnum', CredentialsItemsStateEnum],
    ['CredentialsMeta', CredentialsMeta],
    ['CredentialsMeta', CredentialsMeta],
    ['CredentialsMetaIssuanceMeta', CredentialsMetaIssuanceMeta],
    ['CredentialsMetaIssuanceMeta', CredentialsMetaIssuanceMeta],
    ['ValidationErrorsResponse', ValidationErrorsResponse],
    ['ValidationErrorsResponseCodeEnum', ValidationErrorsResponseCodeEnum],
    ['ValidationErrorsResponseErrors', ValidationErrorsResponseErrors],
    ['ValidationErrorsResponseErrors', ValidationErrorsResponseErrors],
    ['ValidationErrorsResponse', ValidationErrorsResponse],
    ['CredentialCreatePayload', CredentialCreatePayload],
    ['ApiError', ApiError],
    ['CredentialCreateResponse', CredentialCreateResponse],
    ['Credential', Credential],
    ['ApiError', ApiError],
    ['ApiError', ApiError],
    ['ValidationErrorsResponse', ValidationErrorsResponse],
    ['CredentialUpdateResponse', CredentialUpdateResponse],
    ['ApiError', ApiError],
    ['ApiError', ApiError],
    ['Credentials', Credentials],
    ['CredentialUpdateResponse', CredentialUpdateResponse],
    ['ApiError', ApiError],
    ['CredentialPatchPayload', CredentialPatchPayload],
    ['CredentialUpdateResponse', CredentialUpdateResponse],
    ['ApiError', ApiError],
    ['CredentialUpdatePayload', CredentialUpdatePayload],
    ['Int64', Int64],
]);

const capitalizeFirstLetter = (value: string) => value.charAt(0).toUpperCase() + value.slice(1);

const isArray = (target: any): boolean => Array.isArray(target);
const isObject = (target: any): boolean => target != null && typeof target === 'object' && !isArray(target);

export class ObjectSerializer {
    public static findCorrectType(data: any, expectedType: string): string {
        const type = typeMap.get(expectedType);

        if (isObject(data) && typeof type === 'function' && 'discriminator' in type) {
            const discriminatorProperty = type.discriminator;
            if (!discriminatorProperty) return expectedType;
            const typeName = data[discriminatorProperty];
            if (!typeName) return expectedType;
            return typeName;
        }

        return expectedType;
    }

    public static serialize(data: any, type: string, format: string) {
        // Get the actual type of this object
        type = this.findCorrectType(data, type);
        const descriptor = typeMap.get(type);

        if (data == undefined) {
            return data;
        } else if (type.lastIndexOf("Array<", 0) === 0) { // string.startsWith pre es6
            let subType: string = type.replace("Array<", ""); // Array<Type> => Type>
            subType = subType.substring(0, subType.length - 1); // Type> => Type
            const transformedData: any[] = [];
            if (isArray(data)) {
                for (const index in data) {
                    transformedData.push(this.serialize(data[index], subType, format));
                }
            }
            return transformedData;
        } else if (type === "Date") {
            if (format == "date") {
                let month = data.getUTCMonth() + 1;
                month = month < 10 ? "0" + month.toString() : month.toString();
                let day = data.getUTCDate();
                day = day < 10 ? "0" + day.toString() : day.toString();

                return data.getUTCFullYear() + "-" + month + "-" + day;
            } else {
                return data.toISOString();
            }
        } else if (typeof descriptor === 'function') {
            if ('getAttributeTypeMap' in descriptor) {
                // get the map for the correct type.
                const attributeTypes = descriptor.getAttributeTypeMap();
                const typeSerializer = descriptor.getTypeSerializer();
                const instance: Record<string, any> = {};
                for (const index in attributeTypes) {
                    const attributeType = attributeTypes[index];
                    const attributeValue = isObject(data) ? data[attributeType.name] : undefined;
                    if (attributeValue !== undefined) {
                        instance[attributeType.baseName] = typeSerializer.serialize(attributeValue, attributeType.type, attributeType.format);
                    }
                }
                return instance;
            } else {
                return descriptor.serialize(data);
            }
        }
        return data;
    }

    public static deserialize(data: any, type: string, format: string) {
        // polymorphism may change the actual type.
        type = this.findCorrectType(data, type);
        const descriptor = typeMap.get(type);

        if (type.lastIndexOf("Array<", 0) === 0) { // string.startsWith pre es6
            let subType: string = type.replace("Array<", ""); // Array<Type> => Type>
            subType = subType.substring(0, subType.length - 1); // Type> => Type
            const transformedData: any[] = [];
            if (isArray(data)) {
                for (const index in data) {
                    transformedData.push(this.deserialize(data[index], subType, format));
                }
            }
            return transformedData;
        } else if (typeof descriptor === 'function') {
            if ('getAttributeTypeMap' in descriptor) {
                const transformedData: Record<string, any> = {};
                const attributeTypes = descriptor.getAttributeTypeMap();
                const typeSerializer = descriptor.getTypeSerializer();
                for (const index in attributeTypes) {
                    const attributeType = attributeTypes[index];
                    const attributeValue = isObject(data) ? data[attributeType.baseName] : undefined;
                    if (attributeValue !== undefined) {
                        transformedData[attributeType.name] = typeSerializer.deserialize(attributeValue, attributeType.type, attributeType.format);
                    }
                }
                return new descriptor(transformedData);
            } else {
                return descriptor.deserialize(data);
            }
        }
        return this.initialize(data, type, format);
    }

    public static initialize(data: any, type: string, format: string) {
        let descriptor = typeMap.get(type);

        if (!descriptor) {
            const globalName = capitalizeFirstLetter(type);
            const globalTarget = typeof window !== 'undefined'
                ? window
                : typeof global !== 'undefined'
                    ? global
                    : undefined;

            if (globalTarget && Reflect.has(globalTarget, globalName)) {
                descriptor = Reflect.get(globalTarget, globalName);
            }
        }

        if (type.lastIndexOf("Array<", 0) === 0) { // string.startsWith pre es6
            let subType: string = type.replace("Array<", ""); // Array<Type> => Type>
            subType = subType.substring(0, subType.length - 1); // Type> => Type
            const initializedData: any[] = [];
            if (isArray(data)) {
                for (let index in data) {
                    initializedData.push(this.initialize(data[index], subType, format));
                }
            }
            return initializedData;
        } else if (type === "Date") {
            return new Date(data);
        } else if (typeof descriptor === 'function') {
            if ('getAttributeTypeMap' in descriptor) {
                const initializedData = new descriptor(undefined, /* skipDefaultValuesInitialization: */ true);
                const attributeTypes = descriptor.getAttributeTypeMap();
                const typeSerializer = descriptor.getTypeSerializer();
                for (const index in attributeTypes) {
                    const attributeType = attributeTypes[index];
                    const attributeValue = isObject(data) ? data[attributeType.name] : undefined;
                    if (attributeType.required || attributeValue !== undefined) {
                        initializedData[attributeType.name] = typeSerializer.initialize(attributeValue, attributeType.type, attributeType.format);
                    }
                }
                return initializedData;
            }
            return data != null ? descriptor(data) : descriptor();
        } else if (typeof descriptor === 'object') {
            return data != null ? data : '';
        }
        return data;
    }

    /**
     * Normalize media type
     *
     * We currently do not handle any media types attributes, i.e. anything
     * after a semicolon. All content is assumed to be UTF-8 compatible.
     */
    public static normalizeMediaType(mediaType: string | undefined): string | undefined {
        if (mediaType === undefined) {
            return undefined;
        }
        return mediaType.split(";")[0].trim().toLowerCase();
    }

    /**
     * From a list of possible media types, choose the one we can handle best.
     *
     * The order of the given media types does not have any impact on the choice
     * made.
     */
    public static getPreferredMediaType(mediaTypes: Array<string>): string {
        /** According to OAS 3 we should default to json */
        if (!mediaTypes) {
            return "application/json";
        }

        const normalMediaTypes = mediaTypes.map(this.normalizeMediaType);
        let selectedMediaType: string | undefined = undefined;
        let selectedRank: number = -Infinity;
        for (const mediaType of normalMediaTypes) {
            if (supportedMediaTypes[mediaType!] > selectedRank) {
                selectedMediaType = mediaType;
                selectedRank = supportedMediaTypes[mediaType!];
            }
        }

        if (selectedMediaType === undefined) {
            throw new Error("None of the given media types are supported: " + mediaTypes.join(", "));
        }

        return selectedMediaType!;
    }

    /**
     * Convert data to a string according the given media type
     */
    public static stringify(data: any, mediaType: string): string {
        if (mediaType === "application/json") {
            return JSONBigIntNative.stringify(data);
        }

        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.stringify.");
    }

    /**
     * Parse data from a string according to the given media type
     */
    public static parse(rawData: string, mediaType: string | undefined) {
        if (mediaType === undefined) {
            throw new Error("Cannot parse content. No Content-Type defined.");
        }

        if (mediaType === "application/json") {
            /**
             * Since `json-bigint` has problematic support for large floats (https://github.com/sidorares/json-bigint/pull/20),
             * especially with native `BigInt`, which can easily lead to a runtime exception,
             * we use custom post-processing to convert the values correctly with the `BigNumber`
             * lib wich is used in `json-bigint` to handle large numbers.
             */
            return JSONBigInt.parse(rawData, (key, value) => {
                if (value instanceof BigNumber) {
                    if (value.isInteger()) return BigInt(value.toString());
                    return value.toNumber();
                }
                return value;
            });
        }

        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.parse.");
    }
}

// TODO: better import syntax?
import { BaseAPIRequestFactory, RequiredError, COLLECTION_FORMATS } from './baseapi';
import { Configuration } from './configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpFile } from './http';
import { ApiException } from './exception';
import { isCodeInRange } from './util';



/**
 * no description
 */
export class DefaultApiRequestFactory extends BaseAPIRequestFactory {
	
    /**
     * This endpoint is used for creating a credential.
     * Create a Credential
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param CredentialCreatePayload 
     */
    public async createCredential(walletDid: string, entityDid: string, CredentialCreatePayload: CredentialCreatePayload, options?: Configuration): Promise<RequestContext> {
		let config = options || this.configuration;
		
        // verify required parameter 'walletDid' is not null or undefined
        if (walletDid === null || walletDid === undefined) {
            throw new RequiredError('Required parameter walletDid was null or undefined when calling createCredential.');
        }

		
        // verify required parameter 'entityDid' is not null or undefined
        if (entityDid === null || entityDid === undefined) {
            throw new RequiredError('Required parameter entityDid was null or undefined when calling createCredential.');
        }

		
        // verify required parameter 'CredentialCreatePayload' is not null or undefined
        if (CredentialCreatePayload === null || CredentialCreatePayload === undefined) {
            throw new RequiredError('Required parameter CredentialCreatePayload was null or undefined when calling createCredential.');
        }

		
		// Path Params
    	const localVarPath = '/api/widget/{entityDid}/wallet/{walletDid}/credential'
            .replace('{' + 'walletDid' + '}', encodeURIComponent(String(walletDid)))
            .replace('{' + 'entityDid' + '}', encodeURIComponent(String(entityDid)));

		// Make Request Context
    	const requestContext = config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

        // Query Params
	
		// Header Params
	
		// Form Params


		// Body Params
        const contentType = ObjectSerializer.getPreferredMediaType([
            "application/json"
        ]);
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = ObjectSerializer.stringify(
            ObjectSerializer.serialize(CredentialCreatePayload, "CredentialCreatePayload", ""),
            contentType
        );
        requestContext.setBody(serializedBody);

        let authMethod = null;
        // Apply auth methods
        authMethod = config.authMethods["ApiKeyAuth"]
        if (authMethod) {
            await authMethod.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * This endpoint is used to get detailed information about a credential (in draft or issued state).
     * Get a Credential
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     */
    public async getCredential(credentialDid: string, walletDid: string, entityDid: string, options?: Configuration): Promise<RequestContext> {
		let config = options || this.configuration;
		
        // verify required parameter 'credentialDid' is not null or undefined
        if (credentialDid === null || credentialDid === undefined) {
            throw new RequiredError('Required parameter credentialDid was null or undefined when calling getCredential.');
        }

		
        // verify required parameter 'walletDid' is not null or undefined
        if (walletDid === null || walletDid === undefined) {
            throw new RequiredError('Required parameter walletDid was null or undefined when calling getCredential.');
        }

		
        // verify required parameter 'entityDid' is not null or undefined
        if (entityDid === null || entityDid === undefined) {
            throw new RequiredError('Required parameter entityDid was null or undefined when calling getCredential.');
        }

		
		// Path Params
    	const localVarPath = '/api/widget/{entityDid}/wallet/{walletDid}/credential/{credentialDid}'
            .replace('{' + 'credentialDid' + '}', encodeURIComponent(String(credentialDid)))
            .replace('{' + 'walletDid' + '}', encodeURIComponent(String(walletDid)))
            .replace('{' + 'entityDid' + '}', encodeURIComponent(String(entityDid)));

		// Make Request Context
    	const requestContext = config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

        // Query Params
	
		// Header Params
	
		// Form Params


		// Body Params

        let authMethod = null;
        // Apply auth methods
        authMethod = config.authMethods["ApiKeyAuth"]
        if (authMethod) {
            await authMethod.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * This endpoint is used for obtaining the JSON Schema associated with the credential.
     * Get Credential Schema
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     */
    public async getCredentialSchema(credentialDid: string, walletDid: string, entityDid: string, options?: Configuration): Promise<RequestContext> {
		let config = options || this.configuration;
		
        // verify required parameter 'credentialDid' is not null or undefined
        if (credentialDid === null || credentialDid === undefined) {
            throw new RequiredError('Required parameter credentialDid was null or undefined when calling getCredentialSchema.');
        }

		
        // verify required parameter 'walletDid' is not null or undefined
        if (walletDid === null || walletDid === undefined) {
            throw new RequiredError('Required parameter walletDid was null or undefined when calling getCredentialSchema.');
        }

		
        // verify required parameter 'entityDid' is not null or undefined
        if (entityDid === null || entityDid === undefined) {
            throw new RequiredError('Required parameter entityDid was null or undefined when calling getCredentialSchema.');
        }

		
		// Path Params
    	const localVarPath = '/api/widget/{entityDid}/wallet/{walletDid}/credential/{credentialDid}/schema'
            .replace('{' + 'credentialDid' + '}', encodeURIComponent(String(credentialDid)))
            .replace('{' + 'walletDid' + '}', encodeURIComponent(String(walletDid)))
            .replace('{' + 'entityDid' + '}', encodeURIComponent(String(entityDid)));

		// Make Request Context
    	const requestContext = config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

        // Query Params
	
		// Header Params
	
		// Form Params


		// Body Params

        let authMethod = null;
        // Apply auth methods
        authMethod = config.authMethods["ApiKeyAuth"]
        if (authMethod) {
            await authMethod.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * This endpoint is used for issuing a credential.
     * Issue Credential
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param revision The revision number of the verifiable credential.
     */
    public async issueCredential(credentialDid: string, walletDid: string, entityDid: string, revision: number, options?: Configuration): Promise<RequestContext> {
		let config = options || this.configuration;
		
        // verify required parameter 'credentialDid' is not null or undefined
        if (credentialDid === null || credentialDid === undefined) {
            throw new RequiredError('Required parameter credentialDid was null or undefined when calling issueCredential.');
        }

		
        // verify required parameter 'walletDid' is not null or undefined
        if (walletDid === null || walletDid === undefined) {
            throw new RequiredError('Required parameter walletDid was null or undefined when calling issueCredential.');
        }

		
        // verify required parameter 'entityDid' is not null or undefined
        if (entityDid === null || entityDid === undefined) {
            throw new RequiredError('Required parameter entityDid was null or undefined when calling issueCredential.');
        }

		
        // verify required parameter 'revision' is not null or undefined
        if (revision === null || revision === undefined) {
            throw new RequiredError('Required parameter revision was null or undefined when calling issueCredential.');
        }

		
		// Path Params
    	const localVarPath = '/api/widget/{entityDid}/wallet/{walletDid}/credential/{credentialDid}'
            .replace('{' + 'credentialDid' + '}', encodeURIComponent(String(credentialDid)))
            .replace('{' + 'walletDid' + '}', encodeURIComponent(String(walletDid)))
            .replace('{' + 'entityDid' + '}', encodeURIComponent(String(entityDid)));

		// Make Request Context
    	const requestContext = config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

        // Query Params
        if (revision !== undefined) {
        	requestContext.setQueryParam("revision", ObjectSerializer.serialize(revision, "number", ""));
        }
	
		// Header Params
	
		// Form Params


		// Body Params

        let authMethod = null;
        // Apply auth methods
        authMethod = config.authMethods["ApiKeyAuth"]
        if (authMethod) {
            await authMethod.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * This endpoint is used to list available credentials (in draft or issued state).
     * List Credentials
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param schema Filter credentials by their credential schema
     * @param queryStates Filter by the credential state.
     * @param queryMode Filter by ownership of the credential.
     */
    public async listCredentials(walletDid: string, entityDid: string, schema?: string, queryStates?: Array<'draft' | 'issued' | 'abandoned'>, queryMode?: 'All' | 'Presented' | 'Held', options?: Configuration): Promise<RequestContext> {
		let config = options || this.configuration;
		
        // verify required parameter 'walletDid' is not null or undefined
        if (walletDid === null || walletDid === undefined) {
            throw new RequiredError('Required parameter walletDid was null or undefined when calling listCredentials.');
        }

		
        // verify required parameter 'entityDid' is not null or undefined
        if (entityDid === null || entityDid === undefined) {
            throw new RequiredError('Required parameter entityDid was null or undefined when calling listCredentials.');
        }

		
		
		
		
		// Path Params
    	const localVarPath = '/api/widget/{entityDid}/wallet/{walletDid}/credentials'
            .replace('{' + 'walletDid' + '}', encodeURIComponent(String(walletDid)))
            .replace('{' + 'entityDid' + '}', encodeURIComponent(String(entityDid)));

		// Make Request Context
    	const requestContext = config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

        // Query Params
        if (schema !== undefined) {
        	requestContext.setQueryParam("schema", ObjectSerializer.serialize(schema, "string", ""));
        }
        if (queryStates !== undefined) {
        	requestContext.setQueryParam("queryStates", ObjectSerializer.serialize(queryStates, "Array<'draft' | 'issued' | 'abandoned'>", ""));
        }
        if (queryMode !== undefined) {
        	requestContext.setQueryParam("queryMode", ObjectSerializer.serialize(queryMode, "'All' | 'Presented' | 'Held'", ""));
        }
	
		// Header Params
	
		// Form Params


		// Body Params

        let authMethod = null;
        // Apply auth methods
        authMethod = config.authMethods["ApiKeyAuth"]
        if (authMethod) {
            await authMethod.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * This endpoint is used for patching a credential meta and claims.
     * Patch Credential
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param CredentialPatchPayload 
     */
    public async patchCredential(credentialDid: string, walletDid: string, entityDid: string, CredentialPatchPayload: CredentialPatchPayload, options?: Configuration): Promise<RequestContext> {
		let config = options || this.configuration;
		
        // verify required parameter 'credentialDid' is not null or undefined
        if (credentialDid === null || credentialDid === undefined) {
            throw new RequiredError('Required parameter credentialDid was null or undefined when calling patchCredential.');
        }

		
        // verify required parameter 'walletDid' is not null or undefined
        if (walletDid === null || walletDid === undefined) {
            throw new RequiredError('Required parameter walletDid was null or undefined when calling patchCredential.');
        }

		
        // verify required parameter 'entityDid' is not null or undefined
        if (entityDid === null || entityDid === undefined) {
            throw new RequiredError('Required parameter entityDid was null or undefined when calling patchCredential.');
        }

		
        // verify required parameter 'CredentialPatchPayload' is not null or undefined
        if (CredentialPatchPayload === null || CredentialPatchPayload === undefined) {
            throw new RequiredError('Required parameter CredentialPatchPayload was null or undefined when calling patchCredential.');
        }

		
		// Path Params
    	const localVarPath = '/api/widget/{entityDid}/wallet/{walletDid}/credential/{credentialDid}'
            .replace('{' + 'credentialDid' + '}', encodeURIComponent(String(credentialDid)))
            .replace('{' + 'walletDid' + '}', encodeURIComponent(String(walletDid)))
            .replace('{' + 'entityDid' + '}', encodeURIComponent(String(entityDid)));

		// Make Request Context
    	const requestContext = config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

        // Query Params
	
		// Header Params
	
		// Form Params


		// Body Params
        const contentType = ObjectSerializer.getPreferredMediaType([
            "application/json"
        ]);
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = ObjectSerializer.stringify(
            ObjectSerializer.serialize(CredentialPatchPayload, "CredentialPatchPayload", ""),
            contentType
        );
        requestContext.setBody(serializedBody);

        let authMethod = null;
        // Apply auth methods
        authMethod = config.authMethods["ApiKeyAuth"]
        if (authMethod) {
            await authMethod.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

    /**
     * This endpoint is used for updating a credential meta and claims.
     * Update Credential
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param CredentialUpdatePayload 
     */
    public async updateCredential(credentialDid: string, walletDid: string, entityDid: string, CredentialUpdatePayload: CredentialUpdatePayload, options?: Configuration): Promise<RequestContext> {
		let config = options || this.configuration;
		
        // verify required parameter 'credentialDid' is not null or undefined
        if (credentialDid === null || credentialDid === undefined) {
            throw new RequiredError('Required parameter credentialDid was null or undefined when calling updateCredential.');
        }

		
        // verify required parameter 'walletDid' is not null or undefined
        if (walletDid === null || walletDid === undefined) {
            throw new RequiredError('Required parameter walletDid was null or undefined when calling updateCredential.');
        }

		
        // verify required parameter 'entityDid' is not null or undefined
        if (entityDid === null || entityDid === undefined) {
            throw new RequiredError('Required parameter entityDid was null or undefined when calling updateCredential.');
        }

		
        // verify required parameter 'CredentialUpdatePayload' is not null or undefined
        if (CredentialUpdatePayload === null || CredentialUpdatePayload === undefined) {
            throw new RequiredError('Required parameter CredentialUpdatePayload was null or undefined when calling updateCredential.');
        }

		
		// Path Params
    	const localVarPath = '/api/widget/{entityDid}/wallet/{walletDid}/credential/{credentialDid}'
            .replace('{' + 'credentialDid' + '}', encodeURIComponent(String(credentialDid)))
            .replace('{' + 'walletDid' + '}', encodeURIComponent(String(walletDid)))
            .replace('{' + 'entityDid' + '}', encodeURIComponent(String(entityDid)));

		// Make Request Context
    	const requestContext = config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

        // Query Params
	
		// Header Params
	
		// Form Params


		// Body Params
        const contentType = ObjectSerializer.getPreferredMediaType([
            "application/json"
        ]);
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = ObjectSerializer.stringify(
            ObjectSerializer.serialize(CredentialUpdatePayload, "CredentialUpdatePayload", ""),
            contentType
        );
        requestContext.setBody(serializedBody);

        let authMethod = null;
        // Apply auth methods
        authMethod = config.authMethods["ApiKeyAuth"]
        if (authMethod) {
            await authMethod.applySecurityAuthentication(requestContext);
        }

        return requestContext;
    }

}



export class DefaultApiResponseProcessor {

    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to createCredential
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async createCredential(response: ResponseContext): Promise<CredentialCreateResponse > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body: CredentialCreateResponse = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "CredentialCreateResponse", ""
            ) as CredentialCreateResponse;
            return body;
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            const body: ValidationErrorsResponse = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "ValidationErrorsResponse", ""
            ) as ValidationErrorsResponse;
            throw new ApiException<ValidationErrorsResponse>(response.httpStatusCode, body);
        }
        if (isCodeInRange("0", response.httpStatusCode)) {
            const body: ApiError = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "ApiError", ""
            ) as ApiError;
            throw new ApiException<ApiError>(response.httpStatusCode, body);
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: CredentialCreateResponse = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "CredentialCreateResponse", ""
            ) as CredentialCreateResponse;
            return body;
        }

        let body = response.body || "";
    	throw new ApiException<string>(response.httpStatusCode, "Unknown API Status Code!\nBody: \"" + body + "\"");
    }
			
    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to getCredential
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async getCredential(response: ResponseContext): Promise<Credential > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: Credential = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "Credential", ""
            ) as Credential;
            return body;
        }
        if (isCodeInRange("0", response.httpStatusCode)) {
            const body: ApiError = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "ApiError", ""
            ) as ApiError;
            throw new ApiException<ApiError>(response.httpStatusCode, body);
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: Credential = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "Credential", ""
            ) as Credential;
            return body;
        }

        let body = response.body || "";
    	throw new ApiException<string>(response.httpStatusCode, "Unknown API Status Code!\nBody: \"" + body + "\"");
    }
			
    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to getCredentialSchema
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async getCredentialSchema(response: ResponseContext): Promise<any > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: any = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "any", ""
            ) as any;
            return body;
        }
        if (isCodeInRange("0", response.httpStatusCode)) {
            const body: ApiError = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "ApiError", ""
            ) as ApiError;
            throw new ApiException<ApiError>(response.httpStatusCode, body);
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: any = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "any", ""
            ) as any;
            return body;
        }

        let body = response.body || "";
    	throw new ApiException<string>(response.httpStatusCode, "Unknown API Status Code!\nBody: \"" + body + "\"");
    }
			
    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to issueCredential
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async issueCredential(response: ResponseContext): Promise<CredentialUpdateResponse > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body: CredentialUpdateResponse = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "CredentialUpdateResponse", ""
            ) as CredentialUpdateResponse;
            return body;
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            const body: ValidationErrorsResponse = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "ValidationErrorsResponse", ""
            ) as ValidationErrorsResponse;
            throw new ApiException<ValidationErrorsResponse>(response.httpStatusCode, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            const body: ValidationErrorsResponse = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "ValidationErrorsResponse", ""
            ) as ValidationErrorsResponse;
            throw new ApiException<ValidationErrorsResponse>(response.httpStatusCode, body);
        }
        if (isCodeInRange("0", response.httpStatusCode)) {
            const body: ApiError = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "ApiError", ""
            ) as ApiError;
            throw new ApiException<ApiError>(response.httpStatusCode, body);
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: CredentialUpdateResponse = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "CredentialUpdateResponse", ""
            ) as CredentialUpdateResponse;
            return body;
        }

        let body = response.body || "";
    	throw new ApiException<string>(response.httpStatusCode, "Unknown API Status Code!\nBody: \"" + body + "\"");
    }
			
    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to listCredentials
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async listCredentials(response: ResponseContext): Promise<Credentials > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: Credentials = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "Credentials", ""
            ) as Credentials;
            return body;
        }
        if (isCodeInRange("0", response.httpStatusCode)) {
            const body: ApiError = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "ApiError", ""
            ) as ApiError;
            throw new ApiException<ApiError>(response.httpStatusCode, body);
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: Credentials = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "Credentials", ""
            ) as Credentials;
            return body;
        }

        let body = response.body || "";
    	throw new ApiException<string>(response.httpStatusCode, "Unknown API Status Code!\nBody: \"" + body + "\"");
    }
			
    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to patchCredential
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async patchCredential(response: ResponseContext): Promise<CredentialUpdateResponse > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: CredentialUpdateResponse = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "CredentialUpdateResponse", ""
            ) as CredentialUpdateResponse;
            return body;
        }
        if (isCodeInRange("0", response.httpStatusCode)) {
            const body: ApiError = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "ApiError", ""
            ) as ApiError;
            throw new ApiException<ApiError>(response.httpStatusCode, body);
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: CredentialUpdateResponse = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "CredentialUpdateResponse", ""
            ) as CredentialUpdateResponse;
            return body;
        }

        let body = response.body || "";
    	throw new ApiException<string>(response.httpStatusCode, "Unknown API Status Code!\nBody: \"" + body + "\"");
    }
			
    /**
     * Unwraps the actual response sent by the server from the response context and deserializes the response content
     * to the expected objects
     *
     * @params response Response returned by the server for a request to updateCredential
     * @throws ApiException if the response code was not in [200, 299]
     */
     public async updateCredential(response: ResponseContext): Promise<CredentialUpdateResponse > {
        const contentType = ObjectSerializer.normalizeMediaType(response.headers["content-type"]);
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body: CredentialUpdateResponse = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "CredentialUpdateResponse", ""
            ) as CredentialUpdateResponse;
            return body;
        }
        if (isCodeInRange("0", response.httpStatusCode)) {
            const body: ApiError = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "ApiError", ""
            ) as ApiError;
            throw new ApiException<ApiError>(response.httpStatusCode, body);
        }

        // Work around for missing responses in specification, e.g. for petstore.yaml
        if (response.httpStatusCode >= 200 && response.httpStatusCode <= 299) {
            const body: CredentialUpdateResponse = ObjectSerializer.deserialize(
                ObjectSerializer.parse(await response.body.text(), contentType),
                "CredentialUpdateResponse", ""
            ) as CredentialUpdateResponse;
            return body;
        }

        let body = response.body || "";
    	throw new ApiException<string>(response.httpStatusCode, "Unknown API Status Code!\nBody: \"" + body + "\"");
    }
			
}


export interface DefaultApiCreateCredentialRequest {
    /**
     * The DID (Decentralized Identifier) of the wallet.
     * @type string
     * @memberof DefaultApicreateCredential
     */
    walletDid: string
    /**
     * The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @type string
     * @memberof DefaultApicreateCredential
     */
    entityDid: string
    /**
     * 
     * @type CredentialCreatePayload
     * @memberof DefaultApicreateCredential
     */
    CredentialCreatePayload: CredentialCreatePayload
}

export interface DefaultApiGetCredentialRequest {
    /**
     * The DID (Decentralized Identifier) of the credential.
     * @type string
     * @memberof DefaultApigetCredential
     */
    credentialDid: string
    /**
     * The DID (Decentralized Identifier) of the wallet.
     * @type string
     * @memberof DefaultApigetCredential
     */
    walletDid: string
    /**
     * The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @type string
     * @memberof DefaultApigetCredential
     */
    entityDid: string
}

export interface DefaultApiGetCredentialSchemaRequest {
    /**
     * The DID (Decentralized Identifier) of the credential.
     * @type string
     * @memberof DefaultApigetCredentialSchema
     */
    credentialDid: string
    /**
     * The DID (Decentralized Identifier) of the wallet.
     * @type string
     * @memberof DefaultApigetCredentialSchema
     */
    walletDid: string
    /**
     * The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @type string
     * @memberof DefaultApigetCredentialSchema
     */
    entityDid: string
}

export interface DefaultApiIssueCredentialRequest {
    /**
     * The DID (Decentralized Identifier) of the credential.
     * @type string
     * @memberof DefaultApiissueCredential
     */
    credentialDid: string
    /**
     * The DID (Decentralized Identifier) of the wallet.
     * @type string
     * @memberof DefaultApiissueCredential
     */
    walletDid: string
    /**
     * The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @type string
     * @memberof DefaultApiissueCredential
     */
    entityDid: string
    /**
     * The revision number of the verifiable credential.
     * @type number
     * @memberof DefaultApiissueCredential
     */
    revision: number
}

export interface DefaultApiListCredentialsRequest {
    /**
     * The DID (Decentralized Identifier) of the wallet.
     * @type string
     * @memberof DefaultApilistCredentials
     */
    walletDid: string
    /**
     * The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @type string
     * @memberof DefaultApilistCredentials
     */
    entityDid: string
    /**
     * Filter credentials by their credential schema
     * @type string
     * @memberof DefaultApilistCredentials
     */
    schema?: string
    /**
     * Filter by the credential state.
     * @type Array&lt;&#39;draft&#39; | &#39;issued&#39; | &#39;abandoned&#39;&gt;
     * @memberof DefaultApilistCredentials
     */
    queryStates?: Array<'draft' | 'issued' | 'abandoned'>
    /**
     * Filter by ownership of the credential.
     * @type &#39;All&#39; | &#39;Presented&#39; | &#39;Held&#39;
     * @memberof DefaultApilistCredentials
     */
    queryMode?: 'All' | 'Presented' | 'Held'
}

export interface DefaultApiPatchCredentialRequest {
    /**
     * The DID (Decentralized Identifier) of the credential.
     * @type string
     * @memberof DefaultApipatchCredential
     */
    credentialDid: string
    /**
     * The DID (Decentralized Identifier) of the wallet.
     * @type string
     * @memberof DefaultApipatchCredential
     */
    walletDid: string
    /**
     * The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @type string
     * @memberof DefaultApipatchCredential
     */
    entityDid: string
    /**
     * 
     * @type CredentialPatchPayload
     * @memberof DefaultApipatchCredential
     */
    CredentialPatchPayload: CredentialPatchPayload
}

export interface DefaultApiUpdateCredentialRequest {
    /**
     * The DID (Decentralized Identifier) of the credential.
     * @type string
     * @memberof DefaultApiupdateCredential
     */
    credentialDid: string
    /**
     * The DID (Decentralized Identifier) of the wallet.
     * @type string
     * @memberof DefaultApiupdateCredential
     */
    walletDid: string
    /**
     * The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @type string
     * @memberof DefaultApiupdateCredential
     */
    entityDid: string
    /**
     * 
     * @type CredentialUpdatePayload
     * @memberof DefaultApiupdateCredential
     */
    CredentialUpdatePayload: CredentialUpdatePayload
}


export class ObjectDefaultApi {
    private api: ObservableDefaultApi

    public constructor(configuration: Configuration, requestFactory?: DefaultApiRequestFactory, responseProcessor?: DefaultApiResponseProcessor) {
        this.api = new ObservableDefaultApi(configuration, requestFactory, responseProcessor);
	}

    /**
     * This endpoint is used for creating a credential.
     * Create a Credential
     * @param param the request object
     */
    public createCredential(param: DefaultApiCreateCredentialRequest, options?: Configuration): Promise<CredentialCreateResponse> {
        return this.api.createCredential(param.walletDid, param.entityDid, param.CredentialCreatePayload,  options).toPromise();
    }
	
    /**
     * This endpoint is used to get detailed information about a credential (in draft or issued state).
     * Get a Credential
     * @param param the request object
     */
    public getCredential(param: DefaultApiGetCredentialRequest, options?: Configuration): Promise<Credential> {
        return this.api.getCredential(param.credentialDid, param.walletDid, param.entityDid,  options).toPromise();
    }
	
    /**
     * This endpoint is used for obtaining the JSON Schema associated with the credential.
     * Get Credential Schema
     * @param param the request object
     */
    public getCredentialSchema(param: DefaultApiGetCredentialSchemaRequest, options?: Configuration): Promise<any> {
        return this.api.getCredentialSchema(param.credentialDid, param.walletDid, param.entityDid,  options).toPromise();
    }
	
    /**
     * This endpoint is used for issuing a credential.
     * Issue Credential
     * @param param the request object
     */
    public issueCredential(param: DefaultApiIssueCredentialRequest, options?: Configuration): Promise<CredentialUpdateResponse> {
        return this.api.issueCredential(param.credentialDid, param.walletDid, param.entityDid, param.revision,  options).toPromise();
    }
	
    /**
     * This endpoint is used to list available credentials (in draft or issued state).
     * List Credentials
     * @param param the request object
     */
    public listCredentials(param: DefaultApiListCredentialsRequest, options?: Configuration): Promise<Credentials> {
        return this.api.listCredentials(param.walletDid, param.entityDid, param.schema, param.queryStates, param.queryMode,  options).toPromise();
    }
	
    /**
     * This endpoint is used for patching a credential meta and claims.
     * Patch Credential
     * @param param the request object
     */
    public patchCredential(param: DefaultApiPatchCredentialRequest, options?: Configuration): Promise<CredentialUpdateResponse> {
        return this.api.patchCredential(param.credentialDid, param.walletDid, param.entityDid, param.CredentialPatchPayload,  options).toPromise();
    }
	
    /**
     * This endpoint is used for updating a credential meta and claims.
     * Update Credential
     * @param param the request object
     */
    public updateCredential(param: DefaultApiUpdateCredentialRequest, options?: Configuration): Promise<CredentialUpdateResponse> {
        return this.api.updateCredential(param.credentialDid, param.walletDid, param.entityDid, param.CredentialUpdatePayload,  options).toPromise();
    }
	

}





export class ObservableDefaultApi {
    private requestFactory: DefaultApiRequestFactory;
    private responseProcessor: DefaultApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: DefaultApiRequestFactory,
        responseProcessor?: DefaultApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new DefaultApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new DefaultApiResponseProcessor();
    }

    /**
     * This endpoint is used for creating a credential.
     * Create a Credential
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param CredentialCreatePayload 
     */
    public createCredential(walletDid: string, entityDid: string, CredentialCreatePayload: CredentialCreatePayload, options?: Configuration): Observable<CredentialCreateResponse> {
    	const requestContextPromise = this.requestFactory.createCredential(walletDid, entityDid, CredentialCreatePayload, options);

		// build promise chain
    let middlewarePreObservable = from<RequestContext>(requestContextPromise);
    	for (let middleware of this.configuration.middleware) {
    		middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
    	}

    	return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
	    	pipe(mergeMap((response: ResponseContext) => {
	    		let middlewarePostObservable = of(response);
	    		for (let middleware of this.configuration.middleware) {
	    			middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
	    		}
	    		return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createCredential(rsp)));
	    	}));
    }
	
    /**
     * This endpoint is used to get detailed information about a credential (in draft or issued state).
     * Get a Credential
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     */
    public getCredential(credentialDid: string, walletDid: string, entityDid: string, options?: Configuration): Observable<Credential> {
    	const requestContextPromise = this.requestFactory.getCredential(credentialDid, walletDid, entityDid, options);

		// build promise chain
    let middlewarePreObservable = from<RequestContext>(requestContextPromise);
    	for (let middleware of this.configuration.middleware) {
    		middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
    	}

    	return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
	    	pipe(mergeMap((response: ResponseContext) => {
	    		let middlewarePostObservable = of(response);
	    		for (let middleware of this.configuration.middleware) {
	    			middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
	    		}
	    		return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getCredential(rsp)));
	    	}));
    }
	
    /**
     * This endpoint is used for obtaining the JSON Schema associated with the credential.
     * Get Credential Schema
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     */
    public getCredentialSchema(credentialDid: string, walletDid: string, entityDid: string, options?: Configuration): Observable<any> {
    	const requestContextPromise = this.requestFactory.getCredentialSchema(credentialDid, walletDid, entityDid, options);

		// build promise chain
    let middlewarePreObservable = from<RequestContext>(requestContextPromise);
    	for (let middleware of this.configuration.middleware) {
    		middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
    	}

    	return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
	    	pipe(mergeMap((response: ResponseContext) => {
	    		let middlewarePostObservable = of(response);
	    		for (let middleware of this.configuration.middleware) {
	    			middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
	    		}
	    		return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getCredentialSchema(rsp)));
	    	}));
    }
	
    /**
     * This endpoint is used for issuing a credential.
     * Issue Credential
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param revision The revision number of the verifiable credential.
     */
    public issueCredential(credentialDid: string, walletDid: string, entityDid: string, revision: number, options?: Configuration): Observable<CredentialUpdateResponse> {
    	const requestContextPromise = this.requestFactory.issueCredential(credentialDid, walletDid, entityDid, revision, options);

		// build promise chain
    let middlewarePreObservable = from<RequestContext>(requestContextPromise);
    	for (let middleware of this.configuration.middleware) {
    		middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
    	}

    	return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
	    	pipe(mergeMap((response: ResponseContext) => {
	    		let middlewarePostObservable = of(response);
	    		for (let middleware of this.configuration.middleware) {
	    			middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
	    		}
	    		return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.issueCredential(rsp)));
	    	}));
    }
	
    /**
     * This endpoint is used to list available credentials (in draft or issued state).
     * List Credentials
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param schema Filter credentials by their credential schema
     * @param queryStates Filter by the credential state.
     * @param queryMode Filter by ownership of the credential.
     */
    public listCredentials(walletDid: string, entityDid: string, schema?: string, queryStates?: Array<'draft' | 'issued' | 'abandoned'>, queryMode?: 'All' | 'Presented' | 'Held', options?: Configuration): Observable<Credentials> {
    	const requestContextPromise = this.requestFactory.listCredentials(walletDid, entityDid, schema, queryStates, queryMode, options);

		// build promise chain
    let middlewarePreObservable = from<RequestContext>(requestContextPromise);
    	for (let middleware of this.configuration.middleware) {
    		middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
    	}

    	return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
	    	pipe(mergeMap((response: ResponseContext) => {
	    		let middlewarePostObservable = of(response);
	    		for (let middleware of this.configuration.middleware) {
	    			middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
	    		}
	    		return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.listCredentials(rsp)));
	    	}));
    }
	
    /**
     * This endpoint is used for patching a credential meta and claims.
     * Patch Credential
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param CredentialPatchPayload 
     */
    public patchCredential(credentialDid: string, walletDid: string, entityDid: string, CredentialPatchPayload: CredentialPatchPayload, options?: Configuration): Observable<CredentialUpdateResponse> {
    	const requestContextPromise = this.requestFactory.patchCredential(credentialDid, walletDid, entityDid, CredentialPatchPayload, options);

		// build promise chain
    let middlewarePreObservable = from<RequestContext>(requestContextPromise);
    	for (let middleware of this.configuration.middleware) {
    		middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
    	}

    	return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
	    	pipe(mergeMap((response: ResponseContext) => {
	    		let middlewarePostObservable = of(response);
	    		for (let middleware of this.configuration.middleware) {
	    			middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
	    		}
	    		return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.patchCredential(rsp)));
	    	}));
    }
	
    /**
     * This endpoint is used for updating a credential meta and claims.
     * Update Credential
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param CredentialUpdatePayload 
     */
    public updateCredential(credentialDid: string, walletDid: string, entityDid: string, CredentialUpdatePayload: CredentialUpdatePayload, options?: Configuration): Observable<CredentialUpdateResponse> {
    	const requestContextPromise = this.requestFactory.updateCredential(credentialDid, walletDid, entityDid, CredentialUpdatePayload, options);

		// build promise chain
    let middlewarePreObservable = from<RequestContext>(requestContextPromise);
    	for (let middleware of this.configuration.middleware) {
    		middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
    	}

    	return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => this.configuration.httpApi.send(ctx))).
	    	pipe(mergeMap((response: ResponseContext) => {
	    		let middlewarePostObservable = of(response);
	    		for (let middleware of this.configuration.middleware) {
	    			middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
	    		}
	    		return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateCredential(rsp)));
	    	}));
    }
	

}





export class PromiseDefaultApi {
    private api: ObservableDefaultApi

    public constructor(
        configuration: Configuration,
        requestFactory?: DefaultApiRequestFactory,
        responseProcessor?: DefaultApiResponseProcessor
    ) {
        this.api = new ObservableDefaultApi(configuration, requestFactory, responseProcessor);
    }

    /**
     * This endpoint is used for creating a credential.
     * Create a Credential
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param CredentialCreatePayload 
     */
    public createCredential(walletDid: string, entityDid: string, CredentialCreatePayload: CredentialCreatePayload, options?: Configuration): Promise<CredentialCreateResponse> {
    	const result = this.api.createCredential(walletDid, entityDid, CredentialCreatePayload, options);
        return result.toPromise().catch((error) => {
            if (error instanceof ApiException) throw error;
            throw new ApiException<string>(0, error.message);
        });
    }
	
    /**
     * This endpoint is used to get detailed information about a credential (in draft or issued state).
     * Get a Credential
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     */
    public getCredential(credentialDid: string, walletDid: string, entityDid: string, options?: Configuration): Promise<Credential> {
    	const result = this.api.getCredential(credentialDid, walletDid, entityDid, options);
        return result.toPromise().catch((error) => {
            if (error instanceof ApiException) throw error;
            throw new ApiException<string>(0, error.message);
        });
    }
	
    /**
     * This endpoint is used for obtaining the JSON Schema associated with the credential.
     * Get Credential Schema
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     */
    public getCredentialSchema(credentialDid: string, walletDid: string, entityDid: string, options?: Configuration): Promise<any> {
    	const result = this.api.getCredentialSchema(credentialDid, walletDid, entityDid, options);
        return result.toPromise().catch((error) => {
            if (error instanceof ApiException) throw error;
            throw new ApiException<string>(0, error.message);
        });
    }
	
    /**
     * This endpoint is used for issuing a credential.
     * Issue Credential
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param revision The revision number of the verifiable credential.
     */
    public issueCredential(credentialDid: string, walletDid: string, entityDid: string, revision: number, options?: Configuration): Promise<CredentialUpdateResponse> {
    	const result = this.api.issueCredential(credentialDid, walletDid, entityDid, revision, options);
        return result.toPromise().catch((error) => {
            if (error instanceof ApiException) throw error;
            throw new ApiException<string>(0, error.message);
        });
    }
	
    /**
     * This endpoint is used to list available credentials (in draft or issued state).
     * List Credentials
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param schema Filter credentials by their credential schema
     * @param queryStates Filter by the credential state.
     * @param queryMode Filter by ownership of the credential.
     */
    public listCredentials(walletDid: string, entityDid: string, schema?: string, queryStates?: Array<'draft' | 'issued' | 'abandoned'>, queryMode?: 'All' | 'Presented' | 'Held', options?: Configuration): Promise<Credentials> {
    	const result = this.api.listCredentials(walletDid, entityDid, schema, queryStates, queryMode, options);
        return result.toPromise().catch((error) => {
            if (error instanceof ApiException) throw error;
            throw new ApiException<string>(0, error.message);
        });
    }
	
    /**
     * This endpoint is used for patching a credential meta and claims.
     * Patch Credential
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param CredentialPatchPayload 
     */
    public patchCredential(credentialDid: string, walletDid: string, entityDid: string, CredentialPatchPayload: CredentialPatchPayload, options?: Configuration): Promise<CredentialUpdateResponse> {
    	const result = this.api.patchCredential(credentialDid, walletDid, entityDid, CredentialPatchPayload, options);
        return result.toPromise().catch((error) => {
            if (error instanceof ApiException) throw error;
            throw new ApiException<string>(0, error.message);
        });
    }
	
    /**
     * This endpoint is used for updating a credential meta and claims.
     * Update Credential
     * @param credentialDid The DID (Decentralized Identifier) of the credential.
     * @param walletDid The DID (Decentralized Identifier) of the wallet.
     * @param entityDid The DID (Decentralized Identifier) of the entity associated with the wallet.
     * @param CredentialUpdatePayload 
     */
    public updateCredential(credentialDid: string, walletDid: string, entityDid: string, CredentialUpdatePayload: CredentialUpdatePayload, options?: Configuration): Promise<CredentialUpdateResponse> {
    	const result = this.api.updateCredential(credentialDid, walletDid, entityDid, CredentialUpdatePayload, options);
        return result.toPromise().catch((error) => {
            if (error instanceof ApiException) throw error;
            throw new ApiException<string>(0, error.message);
        });
    }
	

}




